import { Group, Text } from "@mantine/core"
import { IconFileUnknown } from "@tabler/icons-react"
import { theme } from "@tfg/themes"

import { DocumentDownload } from "../DocumentDownload/DocumentDownload"
import { DocumentView } from "../DocumentView/DocumentView"

type Props = {
  documentName: string | null
  documentId: string | null
  filename?: string
  fetchViewUrl: () => Promise<string | undefined>
  fetchDownloadUrl: () => Promise<string | undefined>
  missingDocumentText?: string
}

export const DocumentActionsCell = ({
  documentId,
  documentName,
  filename,
  fetchViewUrl,
  fetchDownloadUrl,
  missingDocumentText = "Unable to find document",
}: Props) => {
  if (!documentId || !documentName) {
    return (
      <Group>
        <IconFileUnknown color={theme.colors.gray[7]} />
        <Text>{missingDocumentText}</Text>
      </Group>
    )
  }

  return (
    <Group wrap="nowrap">
      {fetchViewUrl && (
        <DocumentView
          documentId={documentId}
          fetchViewUrl={async () => {
            const viewUrl = await fetchViewUrl()
            if (!viewUrl) {
              return undefined
            }
            return viewUrl
          }}
        />
      )}
      {fetchDownloadUrl && (
        <DocumentDownload
          fetchDownloadUrl={async () => {
            const downloadUrl = await fetchDownloadUrl()
            if (!downloadUrl) {
              return undefined
            }
            return downloadUrl
          }}
          documentName={documentName}
          filename={filename}
        />
      )}
    </Group>
  )
}
